
(function() {
  'use strict';
  const overlay = document.getElementById('svastiOverlay');
  const wrapper = document.getElementById('svastiWrapper');
  const card = document.getElementById('svastiCard');
  // Heading animation might need reset? It uses CSS opacity transition, so cleanProps on wrapper handles it?
  const heading = wrapper.querySelector('.svasti-search-heading');
  const input = document.getElementById('svastiInput');
  const clearBtn = document.getElementById('svastiClear');
  const closeBtn = document.getElementById('svastiClose');
  const results = document.getElementById('svastiResults');
  const resultsInner = document.getElementById('svastiResultsInner');
  if (!overlay || !wrapper || !card || !input) return;
  let isOpen = false;
  let isExpanded = false;
  let searchTimeout = null;
  let triggerElement = null;
  let openingTimer = null;
  let closeTimer = null;
  let closeAnimation = null;
  const triggerSelector = 'search-drawer-trigger, [data-search-trigger], .header-icons .search .header-icon, .header__icon--search';
  
  const isMobile = () => window.innerWidth < 768;

  function closeLegacyDrawer() {
    const legacyDrawer = document.querySelector('search-drawer.open');
    if (!legacyDrawer) return;

    if (typeof legacyDrawer.closeDrawer === 'function') {
      legacyDrawer.closeDrawer();
    } else {
      legacyDrawer.classList.remove('open');
      document.body.classList.remove('no-scroll');
    }
  }

  // =========================================
  // OPEN SEARCH
  // =========================================
  function openSearch(trigger) {
    if (isOpen) return;
    closeLegacyDrawer();
    clearTimeout(closeTimer);
    closeTimer = null;
    clearTimeout(openingTimer);
    if (closeAnimation) {
      closeAnimation.kill();
      closeAnimation = null;
    }
    if (typeof gsap !== 'undefined') {
      gsap.killTweensOf([card, results, overlay, heading]);
    }
    isOpen = true;
    triggerElement = trigger || null;
    // Reset state
    input.value = '';
    clearBtn.classList.remove('visible');
    resultsInner.innerHTML = '';
    
    // Reset structural styles
    if (typeof gsap !== 'undefined') {
      gsap.set(results, { height: 0, opacity: 0 });
      gsap.set(card, { borderRadius: 28 }); // Start as pill (28px)
    } else {
      results.style.height = '0';
      results.style.opacity = '0';
      card.style.borderRadius = '28px';
    }
    wrapper.classList.remove('expanded');
    isExpanded = false;
    // LOCK BODY SCROLL
    // document.body.classList.add('no-scroll');
    
    // Ensure display is block
    overlay.style.display = 'block';
    wrapper.style.display = 'block'; // Make element visible first
    
    // Slight Delay or Force Reflow to ensure CSS transitions trigger
    requestAnimationFrame(() => {
        wrapper.classList.add('active');
        overlay.classList.add('active'); // Fades in opacity + blur
        wrapper.classList.add('opening');
    });
    openingTimer = setTimeout(() => {
      wrapper.classList.remove('opening');
      openingTimer = null;
    }, 450);
    input.focus();
  }
  // =========================================
  // CLOSE SEARCH
  // =========================================
  function closeSearch() {
    if (!isOpen) return;
    isOpen = false;
    clearTimeout(openingTimer);
    openingTimer = null;
    wrapper.classList.remove('opening');
    input.blur();
    
    const logo = wrapper.querySelector('.svasti-search-logo');
    const heading = wrapper.querySelector('.svasti-search-heading');
    
    // LET CSS HANDLE THE BLUR: Remove active class immediately
    // The CSS transition (0.42s cubic-bezier) will smoothly fade the blur
    overlay.classList.remove('active');
    
    if (typeof gsap !== 'undefined') {
        if (closeAnimation) closeAnimation.kill();
        closeAnimation = gsap.timeline({
          onComplete: () => {
            closeAnimation = null;
            finishClose();
          }
        });
        
        // Logo fades first
        closeAnimation.to(logo, { 
            opacity: 0, 
            y: -5,
            duration: 0.2, 
            ease: 'power2.in' 
        }, 0);
        
        // Heading fades slightly after
        closeAnimation.to(heading, { 
            opacity: 0, 
            y: -5,
            duration: 0.1, 
            ease: 'power2.in' 
        }, 0.05);
        
        // Collapse results if expanded
        if (isExpanded) {
             closeAnimation.to(results, { height: 0, opacity: 0, duration: 0.22, ease: 'power2.inOut' }, 0.08);
             closeAnimation.to(card, { borderRadius: 28, duration: 0.22, ease: 'power2.inOut' }, 0.08);
        }
        
        // Card: uniform scale + fade (NO horizontal squeeze)
        closeAnimation.to(card, { 
            scale: 0.92, 
            opacity: 0, 
            duration: 0.28, 
            ease: 'power2.inOut' 
        }, isExpanded ? 0.15 : 0.1);
        
        // NO GSAP overlay animation - CSS handles it via .active class removal
    } else {
        finishClose();
    }
  }
  function finishClose() {
    if (isOpen) return;
    // overlay.classList.remove('active') already done in closeSearch()
    wrapper.classList.remove('active', 'expanded');
    isExpanded = false;
    if (triggerElement) {
      triggerElement.focus();
      triggerElement = null;
    }
    // document.body.classList.remove('no-scroll');
    
    // Reset visual state for next open
    const logo = wrapper.querySelector('.svasti-search-logo');
    const heading = wrapper.querySelector('.svasti-search-heading');
    
    if (typeof gsap !== 'undefined') {
      gsap.set(card, { scale: 1, opacity: 1, clearProps: 'all' });
      gsap.set(overlay, { clearProps: 'all' });
      gsap.set(logo, { clearProps: 'all' });
      gsap.set(heading, { clearProps: 'all' });
    } else {
      card.removeAttribute('style');
      logo.removeAttribute('style');
      heading.removeAttribute('style');
    }
    
    // Delay hiding until CSS blur transition completes (0.42s)
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
        if (isOpen) return;
        overlay.style.display = 'none';
        wrapper.style.display = 'none';
        
        const y = window.scrollY;
        window.scrollTo(0, y - 1);
        window.scrollTo(0, y);
        closeTimer = null;
    }, 450);  // Match CSS transition duration
  }
  // =========================================
  // EXPAND / COLLAPSE
  // =========================================
  function expand() {
    if (isExpanded) return;
    isExpanded = true;
    wrapper.classList.add('expanded');
    
    if (typeof gsap !== 'undefined') {
        const tl = gsap.timeline();
        // SMOOTH TRANSITION: 28px -> 24px (Natural Morph)
        // No more lozenge warping because start radius is correct (28px)
        tl.to(card, { 
            borderRadius: 24, 
            duration: 0.4, 
            ease: 'power2.out' 
        }, 0);
        
        tl.to(results, { 
            height: 'auto', 
            opacity: 1, 
            duration: 0.45, 
            ease: 'expo.out' 
        }, 0);
    } else {
        card.style.borderRadius = '24px';
        results.style.height = 'auto';
        results.style.opacity = '1';
    }
  }
  function collapse() {
    if (!isExpanded) return;
    isExpanded = false;
    wrapper.classList.remove('expanded');
    
    if (typeof gsap !== 'undefined') {
        gsap.to(card, { borderRadius: 28, duration: 0.3, ease: 'power2.out' });
        gsap.to(results, { height: 0, opacity: 0, duration: 0.3, ease: 'power2.out' });
    } else {
        card.style.borderRadius = '28px';
        results.style.height = '0';
        results.style.opacity = '0';
    }
    resultsInner.innerHTML = '';
  }
  // =========================================
  // SEARCH LOGIC
  // =========================================
  async function performSearch(query) {
    if (query.length < 2) { collapse(); return; }
    expand(); 
    resultsInner.innerHTML = '<div class="svasti-search-loading"><div class="svasti-search-spinner"></div></div>';
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
      const res = await fetch(url);
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      if (products.length > 0) resultsInner.innerHTML = buildResultsHTML(products, query);
      else resultsInner.innerHTML = '<div class="svasti-search-empty">No products found</div>';
    } catch (err) {
      console.error('Search error:', err);
      resultsInner.innerHTML = '<div class="svasti-search-empty">Search error</div>';
    }
  }
  function buildResultsHTML(products, query) {
    let html = '<span class="svasti-search-label">Products</span><div class="svasti-search-list">';
    products.forEach(p => {
      let img = p.featured_image?.url || p.image || '';
      if (img) img = img.replace(/\.(jpg|jpeg|png|webp)/gi, '_100x.$1');
      const price = p.price || '';
      html += `<a href="${p.url}" class="svasti-search-item"><div class="svasti-search-item-thumb">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}</div><div><div class="svasti-search-item-title">${escapeHtml(p.title)}</div><div class="svasti-search-item-price">${price}</div></div></a>`;
    });
    html += '</div>';
    html += `<a href="/search?q=${encodeURIComponent(query)}&type=product" class="svasti-search-view-all">View all results</a>`;
    return html;
  }
  function escapeHtml(str) { const div = document.createElement('div'); div.textContent = str || ''; return div.innerHTML; }
  // =========================================
  // EVENT LISTENERS
  // =========================================
  
  // Input & UI Controls
  input.addEventListener('input', (e) => {
    const val = e.target.value.trim();
    if (val.length > 0) clearBtn.classList.add('visible'); else clearBtn.classList.remove('visible');
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => performSearch(val), 280);
  });
  
  clearBtn.addEventListener('click', (e) => { e.preventDefault(); input.value = ''; input.focus(); clearBtn.classList.remove('visible'); collapse(); });
  closeBtn.addEventListener('click', (e) => { e.preventDefault(); closeSearch(); });
  overlay.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) {
      closeSearch();
      return;
    }

    const trigger = e.target.closest?.(triggerSelector);
    if (trigger && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      e.stopPropagation();
      openSearch(trigger);
    }
  }, true);

  // Capture before the original theme's search-drawer-trigger handler.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest?.(triggerSelector);
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openSearch(trigger);
    }
  }, true);
})();
